export default __webpack_public_path__ + "static/media/semfoto.5184601a.svg";